export default{
    computed: {
        
        //状态
        statusList(){
            return [
				{ value: 0, label: '草稿' ,theme: 'gray'},
                { value: 1, label: '待测算' ,theme: 'warning'},
                { value: 2, label: '待确认' ,theme: 'warning'},
				{ value: 3, label: '待上架' ,theme: 'warning'},
                { value: 4, label: '上架中', theme: 'primary' },
                { value: 7, label: '调价上架中' ,theme: 'primary'},
                { value: 5, label: '上架异常', theme: 'error' },
                { value: 6, label: '上架完成', theme: 'success' },
            ]
        },
        
        //调价状态
        adjustStatusList(){
            return [
				{ value: 1, label: '调价待测算' ,theme: 'warning'},
                { value: 2, label: '调价测算完成', theme: 'success' },
            ]
        },

        //产品类型
        productTypeList(){
            return [
				{ value: 0, label: '成品' },
                { value: 1, label: '配件' },
                { value: 2, label: '耗材' }
            ]
        },

        //最小销售单位
        smallSalesUnitList(){
            return [
				{ value: 0, label: 'Bag' },
                { value: 1, label: 'Bar' },
                { value: 2, label: 'Bottle' },
                { value: 3, label: 'Box' },
                { value: 4, label: 'Bundle' },
                { value: 5, label: 'Carton' },
                { value: 6, label: 'Dozen' },
                { value: 7, label: 'Ea' },
                { value: 8, label: 'Pair' },
                { value: 9, label: 'Pcs' },
                { value: 10, label: 'Piece' },
                { value: 11, label: 'Set' },
                { value: 12, label: 'Unit' }
            ]
        },
    }
    
}